import { GetExecutionOutputArgs, GetExecutionOutputArgsOptions } from "./GetExecutionOutputArgs";

export interface GetExecutionOutputFileArgsOptions extends GetExecutionOutputArgsOptions {
    fileType: GetExecutionOutputFileType;
}

export class GetExecutionOutputFileArgs extends GetExecutionOutputArgs {

    public fileType: GetExecutionOutputFileType;

    constructor(options: GetExecutionOutputFileArgsOptions) {
        super(options);
        if (options.fileType == null) throw Error("fileType is required");
        this.fileType = options.fileType;
    }

}


export enum GetExecutionOutputFileType {

    PkResults,
    PkResultsAll,
    PkResultsCustomCalcs

}
